import React, { useState, useEffect } from "react";
import styled from "styled-components";

// components
import { Button, IconButton } from ".";

// assets
import CloseIcon from "assets/icons/close_icon_small.svg";

// utils
import { getCalendar } from "utils/date";

const FilterCard = ({
  initialFilterValues,
  filter,
  searchCount,
  setFilter,
  resetFilter,
}) => {
  const [cardContents, setCardContents] = useState([]);

  useEffect(() => {
    const makeCardContens = () => {
      let arr = [];
      arr.push({
        value: "period",
        text: `${getCalendar(filter.startDt, "yy.mm.dd")} - ${getCalendar(
          filter.endDt,
          "yy.mm.dd",
        )}`,
      });
      if (filter.coachName) {
        arr.push({ value: "coachName", text: filter.coachName });
      }
      if (filter.searchTerm) {
        arr.push({ value: "searchTerm", text: filter.searchTerm });
      }
      setCardContents(arr);
    };
    makeCardContens();
  }, [searchCount]);

  const handleDelete = (value) => {
    let modifiedFilter = {
      ...filter,
      coachInfo: {
        coachName: filter.coachName,
        seqPartnerCoach: filter.seqPartnerCoach,
      },
    };
    let modifiedCardContents = [...cardContents];

    // if only 1 filter left => close the card & reset filter
    if (cardContents.length === 1) {
      resetFilter();
      return;
    }

    if (value === "period") {
      modifiedFilter.startDt = initialFilterValues.startDt;
      modifiedFilter.endDt = initialFilterValues.endDt;
      modifiedFilter.period = "CURRENT_MONTH";
      modifiedCardContents = modifiedCardContents.filter(
        (el) => el.value !== "period",
      );
    } else if (value === "searchTerm") {
      modifiedFilter.searchTerm = initialFilterValues.searchTerm;
      modifiedCardContents = modifiedCardContents.filter(
        (el) => el.value !== "searchTerm",
      );
    } else {
      modifiedFilter.coachInfo.coachName = initialFilterValues.coachName;
      modifiedFilter.coachInfo.seqPartnerCoach =
        initialFilterValues.seqPartnerCoach;
      modifiedCardContents = modifiedCardContents.filter(
        (el) => el.value !== "coachName",
      );
    }
    setFilter(modifiedFilter);
    setCardContents(modifiedCardContents);
  };

  return (
    <Wrapper>
      <FilterContentWrapper>
        {cardContents?.map((el) => {
          return (
            <FilterContent key={el.value}>
              <span>{el.text}</span>
              <IconButton
                src={CloseIcon}
                onClick={() => handleDelete(el.value)}
              />
            </FilterContent>
          );
        })}
      </FilterContentWrapper>

      <CancelButtonWrapper>
        <Button
          variant="text"
          text="취소"
          color="#70747D"
          fontSize="14px"
          onClick={resetFilter}
        />
      </CancelButtonWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 56px;
  min-width: 300px;
  background-color: #f3f6fd;
  display: flex;
  flex-direction: row;
`;

const FilterContentWrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 12px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-y: hidden;
  overflow-x: scroll;
  div:not(:last-child) {
    margin-right: 6px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

const CancelButtonWrapper = styled.div`
  width: 45px;
  height: inherit;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;
`;

const FilterContent = styled.div`
  width: auto;
  min-width: fit-content;
  height: 32px;
  background-color: #ffffff;
  border: 1px solid #e1e6ed;
  border-radius: 24px;
  padding: 6px 14px;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-feature-settings: "tnum" on, "lnum" on;
    color: #515458;
    margin-right: 8px;
  }

  img {
    min-width: 12px;
    min-height: 12px;
  }
`;

export default FilterCard;
